import React from 'react';
import {
  C,
  COUNTDOWN_SETTINGS_W,
  COUNTDOWN_SETTINGS_H,
  nx,
  ny,
} from '../flowCanvas.constants';

const W         = COUNTDOWN_SETTINGS_W;
const HEADER_H  = 40;
const LABEL_X   = 12;
const CONTROL_X = 55;
const CONTROL_W = W - CONTROL_X - 12;
const ROW_Y     = HEADER_H + 10;

const TYPE_OPTIONS = [
  { value: 0, label: 'Image Based' },
  { value: 1, label: 'Text Based' },
  { value: 2, label: 'HMS Countdown' },
  { value: 3, label: 'HMS Count Up' },
];

function getTypeValue(step, liveCustomisationData) {
  const cfg     = step?.customisationConfig;
  const tabKey  = cfg?.tabKey;
  const varKey  = cfg?.varKey;
  const varName = cfg?.variables?.[0]?.variableName;
  const live    = tabKey && varKey && varName
    ? liveCustomisationData?.[tabKey]?.[varKey]?.[varName]
    : null;
  const vals = Array.isArray(live)
    ? live
    : (step?.populatedData?.variables?.[0]?.allValues || []);
  return vals?.[0]?.introType ?? 0;
}

function SelectControl({ x, y, value, options, onChange }) {
  return (
    <foreignObject x={x} y={y} width={CONTROL_W} height="24" style={{ pointerEvents: 'auto' }}>
      <select
        value={value}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onChange={(e) => {
          e.stopPropagation();
          onChange?.(Number(e.target.value));
        }}
        style={{
          width: '100%',
          height: '22px',
          borderRadius: '11px',
          border: '1px solid rgba(145,70,255,0.35)',
          background: 'rgba(145,70,255,0.10)',
          color: 'var(--fc-text)',
          fontSize: '9px',
          fontWeight: 700,
          padding: '0 8px',
          outline: 'none',
          boxSizing: 'border-box',
          cursor: 'pointer',
        }}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value} style={{ background: 'var(--fc-card-bg)', color: 'var(--fc-text)' }}>
            {opt.label}
          </option>
        ))}
      </select>
    </foreignObject>
  );
}

export default function CountdownSettingsNode({
  step,
  selected,
  onClick,
  centreY,
  overrideX,
  overrideY,
  liveCustomisationData,
  onFieldChange,
}) {
  const x    = overrideX ?? nx(step);
  const y    = overrideY ?? ny(step, centreY);
  const left = x - W / 2;
  const top  = y - COUNTDOWN_SETTINGS_H / 2;

  const introType = getTypeValue(step, liveCustomisationData);

  return (
    <g
      className="fc-node fc-node--countdown-settings"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      {/* Drop shadow */}
      <rect
        x={left + 2} y={top + 4}
        width={W} height={COUNTDOWN_SETTINGS_H}
        rx="10" fill="#000" fillOpacity="0.3"
      />

      {/* Card background */}
      <rect
        x={left} y={top}
        width={W} height={COUNTDOWN_SETTINGS_H}
        rx="10"
        fill={selected ? C.cardSel : C.card}
        stroke={selected ? C.sel : C.purple}
        strokeWidth={selected ? 2 : 1.5}
      />

      {/* Header divider */}
      <line
        x1={left + 1} y1={top + HEADER_H}
        x2={left + W - 1} y2={top + HEADER_H}
        stroke={C.border} strokeWidth="1"
      />

      {/* Title */}
      <text
        x={left + 14} y={top + 25}
        fontSize="11.5" fontWeight="700" fill={C.text}
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        {step.stepTitle || 'Countdown Type'}
      </text>

      {/* Row: label */}
      <text
        x={left + LABEL_X} y={top + ROW_Y + 14}
        fontSize="9" fontWeight="700" fill={C.textMuted}
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        Type
      </text>

      {/* Type select dropdown */}
      <SelectControl
        x={left + CONTROL_X}
        y={top + ROW_Y}
        value={introType}
        options={TYPE_OPTIONS}
        onChange={(val) => onFieldChange?.('introType', val)}
      />
    </g>
  );
}
